module.exports = __webpack_public_path__ + "logo2.png?2c59459900b0811a78e5d44549710325";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo2.png
// module id = 1430
// module chunks = 27